import App from '@/App';
import { ROUTES } from '@/configs/constants';
import withAuthentication from '@/hooks/withAuthentication';
import withNonAuthentication from '@/hooks/withNonAuthentication';
import AdminPanelLayout from '@/layouts/AdminPanelLayout';
import FormPanelLayout from '@/layouts/FormPanelLayout';
import { BusinessDashboardPage, CouponTemplateManagementPage, EventTrackingDashboardPage, HelpPage, ItemManagementPage, LandmarkManagementPage, LibraryManagement, LoginPage, MotifTemplateSetManagementPage, NotFoundPage, OmikujiTextsManagementPage, OperationsMapPage, SettingPage, SponsoredCampaignManagementPage, SponsorManagementPage, TablePage, TemplateMotifManagementPage, TierPresetManagementPage, UserManagementPage } from '@/pages';
import SettingFormItem from '@/pages/item-management/components/SettingFormItem';
import { createBrowserRouter, redirect } from 'react-router-dom';

const AdminPanelLayoutWithAuthentication = withAuthentication(AdminPanelLayout);
const FormPanelLayoutWithNoneAuthentication = withNonAuthentication(FormPanelLayout);

export const router = createBrowserRouter([
    {
        path: '/',
        element: <App />,
        children: [
            {
                index: true,
                // 2026-05-16 (Issue 2 fix): role 別 default landing。BUSINESS は /users (= ADMIN-only) に
                // redirect すると 403 で即 logout されるため、/landmarks (= 全 role 共通) に着地させる。
                // ADMIN は従来通り /users に redirect。未ログインは login 画面に流れる (= withAuthentication で gate)。
                loader: () => {
                    const infoRaw = localStorage.getItem('info');
                    let roleId: number | null = null;
                    try {
                        if (infoRaw) {
                            const info = JSON.parse(infoRaw);
                            if (typeof info?.role_id === 'number') roleId = info.role_id;
                        }
                    } catch (_e) {}
                    const target = roleId === 2 ? ROUTES.landmarkManagement.href : ROUTES.userManagement.href;
                    return redirect(target);
                }
            },
            {
                path: '/',
                element: <FormPanelLayoutWithNoneAuthentication />,
                children: [
                    {
                        path: ROUTES.login.href,
                        element: <LoginPage />
                    }
                ]
            },
            {
                path: '/',
                element: <AdminPanelLayoutWithAuthentication />,
                children: [
                    {
                        path: ROUTES.userManagement.href,
                        element: <UserManagementPage />
                    },
                    {
                        path: ROUTES.itemManagement.href,
                        children: [
                            {
                                index: true,
                                element: <ItemManagementPage />
                            },
                            {
                                path: ROUTES.addItem.href,
                                element: <SettingFormItem />
                            },
                            {
                                path: `${ROUTES.updateItem.href}/:id`,
                                element: <SettingFormItem />
                            }

                        ]
                    },
                    {
                        path: ROUTES.libraryManagement.href,
                        element: <LibraryManagement />
                    },
                    {
                        path: ROUTES.setting.href,
                        element: <SettingPage />
                    },
                    {
                        path: ROUTES.landmarkManagement.href,
                        element: <LandmarkManagementPage />
                    },
                    {
                        path: ROUTES.businessDashboard.href,
                        element: <BusinessDashboardPage />
                    },
                    {
                        path: ROUTES.operationsMap.href,
                        element: <OperationsMapPage />
                    },
                    {
                        path: ROUTES.omikujiTextsManagement.href,
                        element: <OmikujiTextsManagementPage />
                    },
                    {
                        path: ROUTES.eventTrackingDashboard.href,
                        element: <EventTrackingDashboardPage />
                    },
                    // T3-B sponsored motif (PR 4, 2026-05-07)
                    {
                        path: ROUTES.sponsorManagement.href,
                        element: <SponsorManagementPage />
                    },
                    {
                        path: ROUTES.sponsoredCampaignManagement.href,
                        element: <SponsoredCampaignManagementPage />
                    },
                    // T3-B PR 4-bis (2026-05-12): omikuji ガチャフレームワーク管理
                    {
                        path: ROUTES.tierPresetManagement.href,
                        element: <TierPresetManagementPage />
                    },
                    {
                        path: ROUTES.motifTemplateSetManagement.href,
                        element: <MotifTemplateSetManagementPage />
                    },
                    {
                        path: ROUTES.templateMotifManagement.href,
                        element: <TemplateMotifManagementPage />
                    },
                    // Coupon management redesign (Phase 2 PR 4, 2026-05-15)
                    {
                        path: ROUTES.couponTemplateManagement.href,
                        element: <CouponTemplateManagementPage />
                    },
                    // 2026-07-07: 操作・項目説明ヘルプ
                    {
                        path: ROUTES.help.href,
                        element: <HelpPage />
                    }
                    // 2026-07-07 (pitfall batch): DashboardPage スタブ削除に伴い commented route も撤去。
                    // {
                    //     path: ROUTES.button.href,
                    //     element: <ButtonPage />
                    // },
                    // {
                    //     path: ROUTES.calendar.href,
                    //     element: <CalendarPage />
                    // },
                    // {
                    //     path: ROUTES.pagination.href,
                    //     element: <PaginationPage />
                    // },
                    // {
                    //     path: ROUTES.table.href,
                    //     element: <TablePage />
                    // }
                    // {
                    //     path: ROUTES.reactToastify.href,
                    //     element: <ReactToastifyPage />
                    // },
                    // {
                    //     path: ROUTES.modal.href,
                    //     element: <ModalPage />
                    // },
                    // {
                    //     path: ROUTES.tabs.href,
                    //     element: <TabsPage />
                    // }
                ]
            },
            {
                path: '*',
                element: <NotFoundPage />
            }
        ]
    }
]);
